import React, { useRef } from "react";
import { useGetBankDetailsQuery, useGetKYCStatusQuery } from "../../app/features/apiSlice";
import Loader from "../Loader";
import Error from "../Error";
import WireTransfer from "./WireTransfer";

const BankDetailCard = ({ planId }) => {
  const sessionId = useRef(Date.now()).current;

  const { data: kycData, isLoading: kycLoading, isError: kycIsError, error: kycError } = useGetKYCStatusQuery({ sessionId });
  const { data, isSuccess, isLoading, isError, error } = useGetBankDetailsQuery(
    { sessionId, planId },
    { skip: kycData?.userStatus?.kyc_status !== "ACCEPTED" } 
  );

  if (kycLoading || isLoading) return <Loader />;
  if (kycIsError) return <Error error={kycError} />;
  if (isError) return <Error error={error} />;

  if (kycData?.userStatus?.kyc_status !== "ACCEPTED") {
    return ""
  }

  return (
    <>
      {isSuccess && data.length > 0 ? (
        data.map((bank, index) => (
          <React.Fragment key={index}>
            <WireTransfer bank={bank} />
          </React.Fragment>
        ))
      ) : (
        ""
      )}
    </>
  );
};

export default BankDetailCard;
